var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.163,
    height: 30.163,
    viewBox: "0 0 30.163 30.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-download",
    "data-name": "Icon awesome-download",
    d: "M12.725,0h4.713a1.411,1.411,0,0,1,1.414,1.414v9.9h5.167a1.176,1.176,0,0,1,.831,2.009l-8.961,8.966a1.141,1.141,0,0,1-1.608,0L5.308,13.32a1.176,1.176,0,0,1,.831-2.009h5.172v-9.9A1.411,1.411,0,0,1,12.725,0ZM30.163,22.151v6.6a1.41,1.41,0,0,1-1.414,1.414H1.414A1.411,1.411,0,0,1,0,28.749v-6.6a1.411,1.411,0,0,1,1.414-1.414h8.642l2.887,2.887a3.019,3.019,0,0,0,4.277,0l2.887-2.887h8.642A1.411,1.411,0,0,1,30.163,22.151Zm-7.305,5.184a1.178,1.178,0,1,0-1.178,1.178A1.182,1.182,0,0,0,22.858,27.335Zm3.77,0a1.178,1.178,0,1,0-1.178,1.178A1.182,1.182,0,0,0,26.628,27.335Z",
    fill: "#0061af"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.d8c0dc62234fa72c610ecc9144fb054d.svg";
export { ForwardRef as ReactComponent };